export interface DynamicConfiguration {
  portalUrlBasename: string;
  flexiApiUrl: string;
  identityServerUrl: string;
  identityServerClientId: string;
  identityServerFlexiApiName: string;
  enableDebugLogging: boolean;
  enableCustomScripts: boolean;
  enableCustomStyles: boolean;
  defaultLanguage: string;
   /**
     * Idle Timeout in minutes.
     *
     * @default 30
     */
  idleTimeout: number;
}

// Type-Guard
export const isDynamicConfiguration = (obj: any, throwError: boolean = false): obj is DynamicConfiguration => {

  const schema: Record<keyof DynamicConfiguration, string | boolean | Record<string, string> | number> = {
    portalUrlBasename: "",
    flexiApiUrl: "",
    identityServerUrl: "",
    identityServerClientId: "",
    identityServerFlexiApiName: "",
    enableDebugLogging: "",
    enableCustomScripts: false,
    enableCustomStyles: false,
    defaultLanguage: "",
    idleTimeout: 0,
  };

  const missingProperties = Object.keys(schema)
      .filter(key => obj[key] === undefined)
      .map(key => key as keyof DynamicConfiguration)
      .map(key => `${key}`);

  if (throwError && missingProperties.length > 0) {
    throw new Error(`In given configuration missing these keys: ${missingProperties.join(", ")}`);
  }

  return missingProperties.length === 0;
}